import type { RiveAnimationProps, RiveControlRef } from "@/types/navigation";
import { Alignment, Fit, Layout, useRive } from "@rive-app/react-canvas";
import { forwardRef, useImperativeHandle } from "react";

export const RiveAnimation = forwardRef<RiveControlRef, RiveAnimationProps>(
  (
    { src, stateMachines = [], autoplay = false, className = "w-full h-full" },
    ref,
  ) => {
    const { rive, RiveComponent } = useRive({
      src,
      stateMachines: stateMachines.length > 0 ? stateMachines : undefined,
      autoplay: false,
      layout: new Layout({
        fit: Fit.Cover,
        alignment: Alignment.Center,
      }),
    });

    useImperativeHandle(ref, () => ({
      play: () => {
        if (rive) {
          rive.play();
        }
      },
      reset: () => {
        if (rive) {
          rive.reset({ autoplay: false });
        }
      },
      reverse: () => {
        if (rive) {
          try {
            rive.scrub(undefined, 0);
          } catch (e) {
            rive.stop();
            rive.reset({ autoplay: false });
          }
        }
      },
      stop: () => {
        if (rive) {
          rive.stop();
        }
      },
    }));

    return (
      <div className={`${className} flex items-center justify-center`}>
        <RiveComponent />
      </div>
    );
  },
);

RiveAnimation.displayName = "RiveAnimation";
